// extracted by mini-css-extract-plugin
export default {"container":"RegisterSuccesModal_container__5I5kP","description":"RegisterSuccesModal_description__4JUVw"};